module.exports = __webpack_public_path__ + "static/img/22.37fe5b66.png";